module.exports = __webpack_public_path__ + "img/form_step_bg.5bd6bb2e.png";